import { JointEntityShape } from '../Shape/JointEntityShape';
import { Aggregation } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/Aggregation';
import { MDAConstant } from '../../Base/MDAConstant';
import { AssoLink } from '../../BaseShape/AssoLink';
import { MDRepository } from '../../../MD/MDRepository';
import { EnumEntityStructureType } from '@/api/com/MetaPattern/MDA/MD/EntityModel/EnumEntityStructureType';

export class JointAggregationLink extends AssoLink {
  constructor(opt?: any) {
    super(opt);
    this.set('type', 'mst.JointAggregationLink');
    this.attr({
      line: {
        stroke: 'orange', // 橙色
        targetMarker: { fill: 'none', d: 'M 10 -5 L 0 0 L 10 5 L 0 0 z' },
        sourceMarker: { fill: 'white', d: 'M 20 0 L 10 5 L 0 0 L 10 -5 z' }
      }
    });
    // 反序列化调用，手工创建的时候不调用
    if (opt) {
      this.setMD(opt?.shape, opt?.model, true);
    }
  }

  changeTarget(source: joint.dia.Element, target: joint.dia.Element) {
    if (target instanceof JointEntityShape && source instanceof JointEntityShape) {
      const sourceEntity = source.entity;
      const targetEntity = target.entity;
      let relationship = this.element() as Aggregation;
      if (relationship === null) {
        relationship = MDRepository.createAggregation(null, sourceEntity, targetEntity, false);
      }
      relationship.name = `${targetEntity.name}_aggregation_${sourceEntity.name}`;
      relationship.displayName = `${targetEntity.displayName}_聚合成_${sourceEntity.displayName}`;
      relationship.description = relationship.displayName;
      relationship.targetEntity = targetEntity;
      this.setModel(relationship);
      sourceEntity.targetAggregations.push(relationship);
      targetEntity.sourceAggregations.push(relationship);
      // 源实体和目标实体相同的时候，实体变更为树形实体，不相同，并不能认定为普通实体
      if (sourceEntity.id === targetEntity.id) {
        sourceEntity.entityStructureType = EnumEntityStructureType.TreeEntity;
      }
      return relationship;
    }
    return null;
  }

  get aggregation(): Aggregation {
    return this.element() as Aggregation;
  }

  public shapeType(): string {
    return MDAConstant.Link.ADD_AGGREGATION;
  }

  /**
   * 检查源和目标类型对当前关系是否有效
   * 聚合关系：仅用于实体与实体
   * @param sourceType 源类型
   * @param targetType 目标类型
   * @returns 有效返回true
   */
  public checkShapeType(sourceType: string, targetType: string): boolean {
    if (sourceType === MDAConstant.Type.ADD_ENTITY && targetType === MDAConstant.Type.ADD_ENTITY) {
      return true;
    }
    return false;
  }
}
